"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListContainer = exports.defaultParams = exports.ModalContext = void 0;
var React = require("react");
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var react_virtualized_auto_sizer_1 = require("react-virtualized-auto-sizer");
var sok_ui_1 = require("@caddigital/sok-ui");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var status_1 = require("@caddigital/sok-reducers/lib/status");
var GenericErrorMessage_1 = require("components/GenericErrorMessage");
var translate_1 = require("utils/translate");
var viewport_1 = require("reducers/viewport");
var utils_1 = require("./utils");
var ListRow_1 = require("./components/ListRow");
var ReliablePartnerSettingsModal_1 = require("./components/ReliablePartnerSettingsModal");
exports.ModalContext = (0, react_1.createContext)({
    selectedCustomer: { reliablePartnerCompanyName: '', uuid: '' },
    setSelectedCustomer: function () { return undefined; }
});
exports.defaultParams = {
    orderBy: 'name',
    order: 'asc'
};
exports.ListContainer = (0, react_1.memo)(function (props) {
    var MODAL_CLEAR_DELAY = 1000;
    var _a = (0, react_1.useState)({
        reliablePartnerCompanyName: '',
        uuid: ''
    }), selectedCustomer = _a[0], setSelectedCustomer = _a[1];
    var _b = (0, react_1.useState)(0), contentWidth = _b[0], setContentWidth = _b[1];
    var _c = (0, react_1.useState)(0), total = _c[0], setTotal = _c[1];
    var _d = (0, react_1.useState)([]), items = _d[0], setItems = _d[1];
    var dispatchProps = (0, utils_1.mapDispatchToProps)((0, react_redux_1.useDispatch)());
    var stateProps = (0, react_redux_1.useSelector)(function (state) {
        var selectedLanguage = (0, translate_1.getLanguage)();
        return {
            list: state.customer.list,
            isMobile: (0, viewport_1.isMobile)(state.viewport),
            selectedLanguage: selectedLanguage,
            user: state.auth.current.user,
            status: state.bid.reliablePartnerSettings.identifierFetchStatus,
            disconnectStatus: state.bid.reliablePartnerSettings.disconnectStatus
        };
    });
    var internalProps = {
        contentWidth: contentWidth,
        setContentWidth: setContentWidth,
        total: total,
        setTotal: setTotal,
        items: items,
        setItems: setItems
    };
    var mergedProps = (0, react_1.useMemo)(function () { return (__assign(__assign(__assign(__assign({}, dispatchProps), stateProps), internalProps), props)); }, [props, internalProps, dispatchProps, stateProps]);
    (0, react_1.useEffect)(function () {
        mergedProps.fetch();
    }, []);
    (0, react_1.useEffect)(function () {
        if (stateProps.status.isSuccess || stateProps.disconnectStatus.isSuccess) {
            mergedProps.fetch();
            mergedProps.toggleModal();
            var timeoutId_1 = setTimeout(function () {
                mergedProps.clear();
            }, MODAL_CLEAR_DELAY);
            return function () { return clearTimeout(timeoutId_1); };
        }
    }, [stateProps.status.value, stateProps.disconnectStatus.value]);
    (0, react_1.useEffect)(function () {
        mergedProps.list && mergedProps.list.status === 'FETCHED'
            ? (0, utils_1.filterAndSortData)(setTotal, setItems, mergedProps)
            : setItems(items);
    }, [mergedProps.list.list, mergedProps.queryParams]);
    (0, react_1.useEffect)(function () {
        (0, utils_1.calculateColumnSizes)(mergedProps.items, mergedProps, mergedProps.setContentWidth);
    }, [items, mergedProps.isMobile]);
    var itemData = (0, react_1.useMemo)(function () { return ({
        style: {},
        isMobile: mergedProps.isMobile,
        items: mergedProps.items,
        selectedLanguage: mergedProps.selectedLanguage
    }); }, [mergedProps.isMobile, mergedProps.items, mergedProps.selectedLanguage]);
    return (React.createElement(exports.ModalContext.Provider, { value: { selectedCustomer: selectedCustomer, setSelectedCustomer: setSelectedCustomer } },
        React.createElement(sok_ui_1.RequestStatusBox, { status: stateProps.status.value, statusList: Object.values(status_1.RequestStatusValue) },
            React.createElement("span", null, (0, translation_1.getLocalization)('customer/notification/modal/fetching')),
            React.createElement("span", null, (0, translation_1.getLocalization)('customer/notification/modal/fetched')),
            React.createElement("span", null, (0, translation_1.getLocalization)('customer/notification/modal/failed'))),
        React.createElement(ReliablePartnerSettingsModal_1.ReliablePartnerSettingsModal, null),
        React.createElement(sok_ui_1.RequestStatusBox, { status: stateProps.disconnectStatus.value, statusList: Object.values(status_1.RequestStatusValue) },
            React.createElement("span", null, (0, translation_1.getLocalization)('customer/notification/modal/remove/fetching')),
            React.createElement("span", null, (0, translation_1.getLocalization)('customer/notification/modal/remove/fetched')),
            React.createElement("span", null, (0, translation_1.getLocalization)('customer/notification/modal/remove/failed'))),
        React.createElement(ReliablePartnerSettingsModal_1.ReliablePartnerSettingsModal, null),
        React.createElement("div", { className: 'management-list-view-list-container' },
            React.createElement("div", { className: 'sok-list-content management-list-view-list ' +
                    mergedProps.list.status.toLowerCase() },
                mergedProps.list.status === 'FAILED' && (React.createElement(GenericErrorMessage_1.default, { key: 'error', title: (0, translation_1.getLocalization)('generic/error') },
                    React.createElement(GenericErrorMessage_1.ErrorButton, { onClick: function () { return mergedProps.fetch(); } }))),
                mergedProps.list.status === 'FETCHING' && (React.createElement("div", { key: 'loading', className: 'loading' },
                    React.createElement(sok_ui_1.LoadingSpinner, null))),
                mergedProps.list.status === 'FETCHED' && mergedProps.items && (React.createElement(react_virtualized_auto_sizer_1.default, null, function (_a) {
                    var width = _a.width, height = _a.height;
                    return (React.createElement(sok_ui_1.List, { itemCount: mergedProps.items.length, itemData: itemData, overscanCount: 8, width: width, height: height, itemHeight: 50, itemWidth: mergedProps.contentWidth, header: React.createElement(utils_1.Header, __assign({}, mergedProps)), placeholder: React.createElement(utils_1.NotFoundPlaceHolder, null) }, ListRow_1.ListRow));
                }))))));
});
